module.exports = ".tchead {\n  color: #212529 !important;\n  border-bottom: 1px solid #d24444 !important; }\n\n.tchead h6 {\n  font-size: 25px;\n  color: #212529;\n  text-align: left;\n  font-weight: 500; }\n\nhtml body {\n  background-color: white !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/contact-details/contact-details.component.scss
// module id = ./src/app/contact-details/contact-details.component.scss
// module chunks = main